import { FiChevronRight, FiExternalLink } from 'react-icons/fi'
import { Link } from 'react-router-dom'
import basBloemProfilePhoto from '@presentation/assets/images/bas-bloem-profile-photo.png'
import ExpertProfileIntro from '@presentation/components/ui/ExpertProfileIntro'
import PodcastCard from '@presentation/components/ui/PodcastCard'
import LoadingSpinner from '@presentation/components/ui/LoadingSpinner'
import { useHomePodcasts } from '@presentation/hooks/useHomePodcasts'

export default function PodcastsSection() {
  const { episodes, loading, error } = useHomePodcasts(3)

  return (
    <section className="box-border bg-background pt-4 pb-2 sm:pt-6 sm:pb-3 lg:pt-8 lg:pb-4">
      <div className="mx-auto flex max-w-7xl flex-col pl-8 pr-4 sm:pl-10 sm:pr-6 lg:pl-14 lg:pr-8">
        <div className="pl-2 sm:pl-4 lg:pl-5">
          <ExpertProfileIntro
            photoSrc={basBloemProfilePhoto}
            photoAlt="Prof. Bas Bloem"
            name="Prof. Bas Bloem"
            affiliation="Radboud University"
            description="A world-leading neurologist and pioneer of patient-centred care, specialising in lifestyle and exercise interventions for Parkinson's."
          />
          <div className="flex shrink-0 items-center justify-between gap-4">
            <Link to="/prof-bas-bloem-weekly" className="no-underline">
              <h2 className="text-2xl font-bold tracking-tight text-blue sm:text-3xl">
                Parkinson's Weekly
              </h2>
            </Link>
            <Link
              to="/prof-bas-bloem-weekly"
              aria-label="View all Parkinson's Weekly podcast episodes"
              className="inline-flex shrink-0 items-center gap-1.5 rounded-lg border border-blue px-3 py-2 text-sm font-semibold text-blue no-underline transition-colors hover:border-blue hover:bg-blue/8"
            >
              View all
              <FiExternalLink className="size-4" aria-hidden="true" />
            </Link>
          </div>
          <div className="mt-3 h-0.5 w-full bg-blue" />
        </div>

        {loading && <LoadingSpinner className="mt-6" />}

        {error && (
          <p className="mt-6 text-center text-text-secondary">
            Unable to load podcasts. Please try again later.
          </p>
        )}

        {!loading && !error && episodes.length === 0 && (
          <p className="mt-6 text-sm font-semibold text-text-secondary">
            No podcast episodes available yet.
          </p>
        )}

        {!loading && !error && episodes.length > 0 && (
          <>
            <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
              {episodes.map((episode, index) => (
                <div
                  key={episode.uid}
                  className={index >= 2 ? 'hidden sm:block' : undefined}
                >
                  <PodcastCard episode={episode} />
                </div>
              ))}
            </div>
            <div className="mt-3 flex shrink-0 justify-center sm:mt-4">
              <Link
                to="/prof-bas-bloem-weekly"
                aria-label="See more Parkinson's Weekly podcast episodes"
                className="inline-flex items-center justify-center gap-1.5 rounded-lg bg-blue px-4 py-3 text-center text-sm font-semibold leading-tight text-white no-underline shadow-sm transition-[transform,opacity,background-color] duration-200 hover:scale-[1.02] hover:bg-blue/90 hover:opacity-90 sm:text-base"
              >
                See more Parkinson&apos;s Weekly episodes
                <FiChevronRight className="size-4" aria-hidden="true" />
              </Link>
            </div>
          </>
        )}
      </div>
    </section>
  )
}
